import { LI, P, UL } from "../../../../../AbstractElements";
import { Col, Row } from "reactstrap";
import {
  amount,
  attachment,
  destination,
  distance,
  mode,
  NA,
  source,
  status,
  username,
} from "../../../../../utils/Constant";
import { dateConversion } from "../../../../../utils/dateUtils";

const ORDERED_CONVEYANCE_KEYS = [
  "date",
  source,
  destination,
  mode,
  distance,
  amount,
  status,
  username,
  attachment,
];

const EXCLUDED_KEYS = [username, attachment];

const ConveyanceListDetails = ({ details }: { details: any }) => {
  return (
    <UL>
      <Row>
        {details && (
          <UL>
            {ORDERED_CONVEYANCE_KEYS.filter(
              (key) =>
                details[key] !== undefined &&
                !EXCLUDED_KEYS.includes(key.toLowerCase())
            ).map((key) => {
              const value = details[key];
              return (
                <LI key={key}>
                  <Row>
                    <Col md="3">
                      <P className="m-0 text-capitalize">{key}</P>
                    </Col>
                    <Col md="1">
                      <P className="m-0">-</P>
                    </Col>
                    <Col md="8">
                      <P className="m-0 text-capitalize">
                        {key === "date"
                          ? dateConversion(value ?? "", true)
                          : value || NA}
                      </P>
                    </Col>
                  </Row>
                </LI>
              );
            })}
          </UL>
        )}
      </Row>
    </UL>
  );
};

export default ConveyanceListDetails;
